export default {
  upgradeToPro: 'What are you waiting for?',
  upgradeToProMessage: 'Upgrade your business to Pro!',
  upgradeToProButton: 'I want to upgrade',
  balanceLimit: 'You have reached your balance limit!',
  balanceLimitMessage: 'Top up balance',
  remindLater: 'Remind me later',
  topUp: 'Recharge balance',
  credit: 'Credit Card',
  debit: 'Debit',
  cash: 'Cash',
  crypto: 'Crypto',
  balanceInput: 'Balance',
  balanceMethodMessage: 'How would you like to pay?',
  anotherMethod: 'Other payment method',
  balancePay: 'Pay',
  rechargeValidate: 'You are about to recharge your Keybe, do you want to continue?',
  keybeMessage: 'Keep enjoying everything that Keybe has for your business',
  addCreditCard: 'Add credit card',
  balanceError: 'Enter a value greater than or equal to {} USD',
  tcError: 'There\'s are problem with the payment. Please try again later!',
  tcSuccess: 'The balance advance was executed correctly! Thanks!',
  balanceTooltip: 'Currently balance',
  selectPaymentMethodMessage: 'Select the payment method you want!',
  noDevelopMethods: 'We are under construction To give you a better experience!',
  creditCardMessage: 'Balance with Credit Card',
  balanceAdd: 'Want to add more balance in favor?',
  cashPaymentTitle: 'We have an account for you!',
  informationName: 'Name:',
  informationBank: 'Bank:',
  informationAccount: 'Account number:',
  informationAddress: 'Address:',
  informationCity: 'City:',
  informationState: 'State:',
  informationEmailMessage: 'At the end of the payment process, send us an email with the subject ADVANCE OF BALANCE to the email',
  informationEmailRemind: 'Don`t forget to send us proof of payment!',
  creditCardAlert: 'Do yo want to delete this Credit Card?',
  isProfessional: 'You are Professional!',
  minAmount: 'Minimum transaction amount',
  seeConsumptions: 'See consumptions'
}
